import React from 'react';
import {AdminPayoutsVO} from "../../../types/model/valueObject/payout/AdminPayoutsVO";
import {formatCurrencyValue} from "../../../util/PaymentUtils";
import {
  CollapsableCardBodyContainer,
  CollapsableCardClickableContainer,
  CollapsableCardCollapseContainer,
  CollapsableCardContainer,
  CollapsableCardExpandIconButton,
  CollapsableCardHeaderActionsContainer,
  CollapsableCardHeaderContainer,
  CollapsableCardHeaderItem,
  CollapsableCardBodyItem
} from "../../cardComponents";

type AdminPayoutsCardListItemProps = {
  item: AdminPayoutsVO;
  expanded?: boolean;
  onToggleExpand: () => void;
}

/**
 * Component that displays all information for a single payout
 * @param item the AdminPayoutsVO to display
 * @param expanded whether the card is expanded or not
 * @param onToggleExpand callback to toggle the expanded state
 * @constructor
 */
const AdminPayoutsCardListItem = ({ item, expanded, onToggleExpand }: AdminPayoutsCardListItemProps) => {
  return (
    <CollapsableCardContainer expanded={expanded}>
        <CollapsableCardClickableContainer onClick={onToggleExpand}>
          <CollapsableCardHeaderContainer>
            <CollapsableCardHeaderItem value={item?.payoutId} label={'Payout ID'} />
            <CollapsableCardHeaderItem value={item?.supplierCompanyName} label={'Company Name'} />
            <CollapsableCardHeaderItem value={item?.locationName} label={'Location Name'} />
            <CollapsableCardHeaderItem value={item?.status} label={'Status'} />
            <CollapsableCardHeaderItem value={item?.createdOn} label={'Payout Initiated'} />
            <CollapsableCardHeaderItem value={item?.completedOn} label={'Payout Completed'} />
            <CollapsableCardHeaderActionsContainer>
              <CollapsableCardExpandIconButton expanded={expanded ?? false} />
            </CollapsableCardHeaderActionsContainer>
          </CollapsableCardHeaderContainer>
        </CollapsableCardClickableContainer>
        <CollapsableCardCollapseContainer in={expanded}>
          <CollapsableCardBodyContainer>
            <CollapsableCardBodyItem value={formatCurrencyValue(item?.grossAmount, true)} label={'Gross Amount'} />
            <CollapsableCardBodyItem value={formatCurrencyValue(item?.buyerAmount, true)} label={'Buyer Amount'} />
            <CollapsableCardBodyItem value={formatCurrencyValue(item?.supplierAmount, true)} label={'Supplier Amount'} />
            <CollapsableCardBodyItem value={formatCurrencyValue(item?.paymentProcessorAmount, true)} label={'Payment Processor Amount'} />
            <CollapsableCardBodyItem value={formatCurrencyValue(item?.securspaceAmount, true)} label={'Securspace Amount'} />
            <CollapsableCardBodyItem value={item?.transactionCount} label={'Transaction Count'} />
          </CollapsableCardBodyContainer>
        </CollapsableCardCollapseContainer>
      </CollapsableCardContainer>
  );
};

export { AdminPayoutsCardListItem };
